// @flow
import * as React from 'react';
import { useState, useEffect } from 'react';
import type { Element } from 'react';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import theme from '@theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { components } from 'react-select';
import { library } from '@fortawesome/fontawesome-svg-core';

import { connect } from 'react-redux';
import compose from 'lodash/fp/compose';
import { requestDoctorListSearchBar } from '../../../redux/actions';
import type { Props } from './types';
import useDebounce from './debounce';
import { StyledForm, StyledSelectInput } from './styles';

library.add(faSearch);

const CaretDownIcon = () => <FontAwesomeIcon icon={faSearch} />;

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <CaretDownIcon />
  </components.DropdownIndicator>
);

const { colors } = theme;

const customStyles = {
  option: (provided, state) => {
    const obj = {
      ...provided,
      color: `${colors.darkBlue}`,
      padding: 16,
      overflowWrap: 'break-word',
      hyphens: 'auto'
    };
    if (state.isSelected) {
      obj.backgroundColor = `${colors.aquaMarine}`;
      obj.color = `${colors.white};`;
    }
    return obj;
  },
  dropdownIndicator: provided => ({
    ...provided,
    color: `${colors.translucentDarkBlue}`
  }),
  placeholder: provided => ({
    ...provided,
    color: `${colors.translucentDarkBlue}`,
    fontWeight: '700',
    fontSize: '20px',
    '@media only screen and (max-width: 1024px)': {
      fontSize: '14px'
    },
    '@media only screen and (max-width: 336px)': {
      fontSize: '10px'
    },
    '@media only screen and (max-width: 280px)': {
      fontSize: '8px'
    }
  }),
  input: styles => ({ ...styles, color: `${colors.darkBlue}` }),
  singleValue: provided => ({
    ...provided,
    color: `${colors.translucentDarkBlue}`,
    fontWeight: '700'
  }),

  control: styles => ({
    ...styles,
    backgroundColor: 'transparent',
    border: 'none',
    appearance: 'none',
    flex: '1',
    width: '100%',
    focus: 'none',
    boxShadow: 'none',
    color: 'white'
  }),
  menuList: base => ({
    ...base,
    paddingTop: '0px',
    paddingBottom: '0px',
    marginTop: '0px',
    '::-webkit-scrollbar': {
      width: '20px',
      '@media only screen and (max-width: 736px)': {
        width: '12px'
      }
    },
    '::-webkit-scrollbar-track': {
      background: 'white'
    },
    '::-webkit-scrollbar-thumb': {
      background: `${colors.translucentDarkBlue}`,
      borderRadius: '10px',
      height: '182px',
      border: '5px solid white',
      '@media only screen and (max-width: 736px)': {
        border: '3px solid white'
      }
    }
  })
};

const StyledSelect = ({
  setted,
  query,
  requestDoctorListSearchBar,
  onChange,
  options,
  ...restProps
}: Props): Element<any> => {
  const [doctorName, setDoctorName] = useState('');
  const debounceSearchTerm = useDebounce(doctorName, 500);

  useEffect(() => {
    setDoctorName((options || []).find(option => option.key === query.query) || '');
  }, [query.query]);

  useEffect(() => {
    requestDoctorListSearchBar({ ...query, doctorName: debounceSearchTerm });
  }, []);

  const handleChange = (e) => {
    onChange(e);
    setDoctorName(e);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  return (
    <StyledForm
      setted={setted}
      onKeyDown={handleKeyDown}
    >
      <StyledSelectInput
        {...restProps}
        options={options}
        styles={customStyles}
        components={{ DropdownIndicator }}
        value={doctorName}
        onChange={e => handleChange(e)}
      />
    </StyledForm>
  );
};
StyledSelect.defaultProps = {
  setted: false
};

const mapStateToProps = state => ({
  SearchObjectList: state.doctorFinder.searchdata
});

export default compose(
  connect(
    mapStateToProps,
    { requestDoctorListSearchBar }
  )
)(StyledSelect);
